(function () {
  var DOS_CHAR_MS = 48;
  var DOS_START_DELAY = 120;
  var MOBILE_MQ = window.matchMedia('(max-width: 760px)');

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return MOBILE_MQ.matches;
  }

  function initDosTypewriters(root) {
    var lines = root.querySelectorAll('[data-dos-type]');
    Array.prototype.forEach.call(lines, function (el) {
      if (el.dataset.dosInit === 'true') return;
      el.dataset.dosInit = 'true';

      var text = el.getAttribute('data-dos-text') || '';
      var out = el.querySelector('[data-dos-out]');
      if (!out || !text) return;

      var timer = null;
      var idx = 0;
      var reduced = prefersReducedMotion();
      var card = el.closest('[data-realisation-card]');

      function clearTimer() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      function reset() {
        clearTimer();
        idx = 0;
        out.textContent = '';
        el.classList.remove('is-typing', 'is-done');
      }

      function finish() {
        clearTimer();
        el.classList.remove('is-typing');
        el.classList.add('is-done');
      }

      function typeStep() {
        if (idx >= text.length) {
          finish();
          return;
        }
        out.textContent += text.charAt(idx);
        idx += 1;
        timer = setTimeout(typeStep, DOS_CHAR_MS);
      }

      function showInstant() {
        clearTimer();
        out.textContent = text;
        el.classList.remove('is-typing');
        el.classList.add('is-done');
      }

      function start() {
        if (reduced || isMobileViewport()) {
          showInstant();
          return;
        }
        reset();
        el.classList.add('is-typing');
        timer = setTimeout(typeStep, DOS_START_DELAY);
      }

      if (isMobileViewport()) {
        showInstant();
      } else if (card) {
        card.addEventListener('mouseenter', start);
        card.addEventListener('mouseleave', function () {
          if (!reduced) reset();
        });
      }
    });
  }

  function initRealisations(root) {
    if (!root) return;
    initDosTypewriters(root);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-stellar-realisations]');
    Array.prototype.forEach.call(roots, initRealisations);
  }

  function onCollectionReloaded() {
    var roots = document.querySelectorAll('[data-stellar-realisations]');
    Array.prototype.forEach.call(roots, function (root) {
      root.querySelectorAll('[data-dos-type]').forEach(function (el) {
        delete el.dataset.dosInit;
      });
      initRealisations(root);
    });

    var filterSection = document.getElementById('CollectionFiltersSection');
    if (
      filterSection &&
      typeof theme !== 'undefined' &&
      theme.sections &&
      theme.sections.reinit
    ) {
      theme.sections.reinit('collection-filter');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('collection:reloaded', onCollectionReloaded);
})();
